// Cookie expiration constants
export const REFRESH_TOKEN_MAX_AGE = 365 * 24 * 60 * 60; // 365 days in seconds